/**
 * Created by Josef Jurca on 2.11.2017.
 */
import {getInstance as getDataSources} from 'datasources';
import {getDevice as getDeviceUtil} from 'utils/device/device';

// Action types
const ActionTypes = {
        SET_DEVICE: 'SET_DEVICE',
        SET_DEVICE_STATUS: 'SET_DEVICE_STATUS',
        ATTEMPT_TO_REMOVE_DEVICE: 'ATTEMPT_TO_REMOVE_DEVICE'
    },

    // Status values
    DeviceStatuses = {
        INITIAL: 'initial',
        GENERATED: 'generated'
    };

/**
 * Creates and returns a set device action.
 *
 * @param {Device} device - Device.
 * @returns {Object} Set device action.
 */
function setDevice (device) {
    return {
        type: ActionTypes.SET_DEVICE,
        device
    };
}

/**
 * Creates and returns a set device status action.
 *
 * @param {string} deviceStatus - Device.
 * @returns {Object} Set device status action.
 */
function setDeviceStatus (deviceStatus) {
    return {
        type: ActionTypes.SET_DEVICE_STATUS,
        status: deviceStatus
    };
}

/**
 * Gets generated device ID.
 *
 * @returns {Object} Get device action.
 */
function getDevice () {
    let dataSources = getDataSources();

    return (dispatch, getState) => {

        let {device : currentDevice} = getState(),
            {status} = currentDevice;

        if (status === DeviceStatuses.GENERATED) {
            return Promise.resolve(currentDevice);
        }

        return getDeviceUtil()
            .then(device => {
                dataSources.updateDeviceID(device);
                dispatch(setDevice(device));
                dispatch(setDeviceStatus(DeviceStatuses.GENERATED));
            });
    };
}

/**
 * Changes device status to 'REMOVING'.
 *
 * @param {Device} device - Device.
 * @returns {Object} Get device action.
 */
function removeDevice (device) {
    return {
        type: ActionTypes.ATTEMPT_TO_REMOVE_DEVICE,
        device
    };
}

export {
    ActionTypes,
    DeviceStatuses,
    setDevice,
    setDeviceStatus,
    removeDevice,
    getDevice
};



// WEBPACK FOOTER //
// ./src/js/store/actions/device.js